module.exports = __webpack_public_path__ + "static/img/2.46e0f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/2.png
// module id = 7QDV
// module chunks = 0